
import "../../Styles/Common/AnswerBlock.scss";
import { cloudFront_URL } from "../../service/API_URL";

const AnswerBlock = ({ includeIcon, data, index }) => {
  return (
    <div className="answerBlock">
      <label className="label">Option {index}</label>
      <div className="answer">
        {includeIcon && (
          <div className="isOptionIcon">
            <img src={cloudFront_URL + data.sourcePath} alt="icon" />
          </div>
        )}
        <div className="option">{data.option}</div>
      </div>
    </div>
  );
};

export default AnswerBlock;
